import { EditIcon } from '@/components/_common';
import { SpedDocument } from '@/core/domain/sped/sped-documents/sped-documents.types';
import { useHistory } from 'react-router-dom';

interface Props {
  spedDocument: SpedDocument;
}

export default function SpedDocumentEditAction({ spedDocument }: Props) {
  const history = useHistory();

  return (
    <EditIcon
      iconProps={{
        onClick: () => history.push(`documents/${spedDocument.id}`),
      }}
    />
  );
}
